import { NextResponse } from 'next/server'

const contentType = "image/svg+xml"
const cacheControl = "public, max-age=0, must-revalidate"
const buffer = Buffer.from("PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjMDcwODA3Ii8+CiAgPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTEiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0M0QTM1QSIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSI2IiBmaWxsPSJub25lIiBzdHJva2U9IiNDNEEzNUEiIHN0cm9rZS13aWR0aD0iMC44Ii8+CiAgPHBhdGggZD0iTTE2IDN2Nk0xNiAyM3Y2TTMgMTZoNk0yMyAxNmg2IiBzdHJva2U9IiNDNEEzNUEiIHN0cm9rZS13aWR0aD0iMSIvPgo8L3N2Zz4K", 'base64')

export function GET() {
    return new NextResponse(buffer, {
        headers: {
            'Content-Type': contentType,
            'Cache-Control': cacheControl,
        },
    })
}

export const dynamic = 'force-static'
